/*
================================================================
IMPORTS
================================================================
*/

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csspointerevents-touchevents-setclasses !*/
 !function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase();Modernizr.addTest("csspointerevents",function(){var e=i("a").style;return e.cssText="pointer-events:auto","auto"===e.pointerEvents});var h=d.testStyles=l,v=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=v,Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",v.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");h(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var m=0;m<Modernizr._q.length;m++)Modernizr._q[m]();e.Modernizr=Modernizr}(window,document);


var tm_body = document.querySelector('body');
var tm_html = document.querySelector('html');
var tm_header = document.querySelector('.site-header');

var Flickity = require('flickity');

import 'lazysizes';

/*
================================================================
ACCESSIBILITY
================================================================
*/

(function () {
    'use strict';

    function keyboardFocus (e) {
        if (e.keyCode !== 9) {
            return;
        }

        switch (e.target.nodeName.toLowerCase()) {
            case 'input':
            case 'select':
            case 'textarea':
                break;
            default:
                document.documentElement.classList.add('keyboard-focus');
                document.removeEventListener('keydown', keyboardFocus, false);
        }
    }

    document.addEventListener('keydown', keyboardFocus, false);
})();


/*
================================================================
IOS VH
================================================================
*/
function getVH(){
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	console.log(vh);
}

// getVH();

window.addEventListener('resize', getVH);

/*
================================================================
SUMMARY ELEMENTS
================================================================
*/


function getFocusableElements(container) {
	return Array.from(
	  container.querySelectorAll(
		"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
	  )
	);
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
	
	if(summary.nextElementSibling.getAttribute('id')) {
	  summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}
  
	summary.addEventListener('click', (event) => {
	  event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
	});
  
	if (summary.closest('header-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });

//   document.querySelectorAll('[id^="Close-"]').forEach((closebtn) => {
// 	closebtn.setAttribute('role', 'button');
// 	closebtn.setAttribute('aria-expanded', false);
// 	closebtn.setAttribute('aria-controls', closebtn.closest('[id^="Sidebar-"]').id);
// 	closebtn.addEventListener('click', closeButton);
//   });

//   document.querySelectorAll('.sidebar-mask').forEach((elem) => {
// 	elem.addEventListener('click', closeButton);
//   });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];
  
	removeTrapFocus();
  
	trapFocusHandlers.focusin = (event) => {
	  if (
		event.target !== container &&
		event.target !== last &&
		event.target !== first
	  )
		return;
  
	  document.addEventListener('keydown', trapFocusHandlers.keydown);
	};
  
	trapFocusHandlers.focusout = function() {
	  document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};
  
	trapFocusHandlers.keydown = function(event) {
	  if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
	  // On the last focusable element and tab forward, focus the first element.
	  if (event.target === last && !event.shiftKey) {
		event.preventDefault();
		first.focus();
	  }
  
	  //  On the first focusable element and tab backward, focus the last element.
	  if (
		(event.target === container || event.target === first) &&
		event.shiftKey
	  ) {
		event.preventDefault();
		last.focus();
	  }
	};
  
	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);
  
	elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
	document.querySelector(":focus-visible");
  } catch(e) {
	focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
	const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
	let currentFocusedElement = null;
	let mouseClick = null;
  
	window.addEventListener('keydown', (event) => {
	  if(navKeys.includes(event.code.toUpperCase())) {
		mouseClick = false;
	  }
	});
  
	window.addEventListener('mousedown', (event) => {
	  mouseClick = true;
	});
  
	window.addEventListener('focus', () => {
	  if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
	  if (mouseClick) return;
  
	  currentFocusedElement = document.activeElement;
	  currentFocusedElement.classList.add('focused');
  
	}, true);
  }
  
//   function pauseAllMedia() {
// 	document.querySelectorAll('.js-youtube').forEach((video) => {
// 	  video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
// 	});
// 	document.querySelectorAll('.js-vimeo').forEach((video) => {
// 	  video.contentWindow.postMessage('{"method":"pause"}', '*');
// 	});
// 	document.querySelectorAll('video').forEach((video) => video.pause());
// 	document.querySelectorAll('product-model').forEach((model) => {
// 	  if (model.modelViewerUI) model.modelViewerUI.pause();
// 	});
//   }
  
  function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
	if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;
  
	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;
  
	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
  }

  function closeButton(event){
	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;
  
	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
  }

/*
================================================================
SCROLL MENU
================================================================
*/

class ScrollMenu {
	constructor(el) {
		this.el = el;
		this.links = el.querySelectorAll('a[href^="#section-"]');
		this.links.forEach((link) => {
			link.addEventListener('click', (e) => this.scrollToSection(e));
			console.log(this.el );
		});
	}
	scrollToSection(e) {
		e.preventDefault();
		let target = document.getElementById(e.target.dataset.link);
		let offset = target.offsetTop - tm_header.offsetHeight;
		window.scroll({
			top: offset,
			left: 0,
			behavior: 'smooth'
		});
		if(this.el.classList.contains('mobile-menu')){
			const menu = this.el.closest('details');
			console.log(menu);
			menu.open = false;
		}
	  }
  }

  document.querySelectorAll('.page-menu').forEach((el) => {
	new ScrollMenu(el);
  });

  class ScrollLink {
	constructor(el) {
		this.el = el;
		el.addEventListener('click', (e) => this.scrollToSection(e));
		
	}
	scrollToSection(e) {
		e.preventDefault();
		let target = document.getElementById(e.target.dataset.link);
		let offset = target.offsetTop - tm_header.offsetHeight;
		window.scroll({
			top: offset,
			left: 0,
			behavior: 'smooth'
		});
	  }
  }

  document.querySelectorAll('.scroll-link').forEach((el) => {
	new ScrollLink(el);
  });

/*
================================================================
COOKIE CONSENT
================================================================
*/
var lang = document.documentElement.lang;

var cc = initCookieConsent();

// run plugin with config object
cc.run({
	autorun : true, 
	delay : 0,
	current_lang : lang,
	auto_language : false,
	autoclear_cookies : true,
	cookie_expiration : 365,
	force_consent: false,
    gui_options: {
        consent_modal : {
            transition: 'slide'             // zoom/slide
        },
        settings_modal : {
            layout : 'bar',                 // box/bar
            // position : 'left',           // left/right
            transition: 'slide'             // zoom/slide
        }
    },
	onAccept: function(cookie){
		console.log("onAccept fired ...");
		
		if(cc.allowedCategory('analytics')){
			cc.loadScript('https://www.googletagmanager.com/gtag/js?id=G-PKT903TN6G', function(){		
				window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-PKT903TN6G');
				gtag('send', 'pageview');
				console.log("analytics loaded");
			});
		}
	},

	onChange: function(cookie){
		console.log("onChange fired ...");
		
		// delete line below
		typeof doDemoThings === 'function' && doDemoThings(cookie);
	},

	languages : {
		'en' : {	
			consent_modal : {
				title :  "Cookies",
				description :  'This site uses cookies. For more information please read our <a href="/privacy">privacy policy.</a>',
				primary_btn: {
					text: 'Accept',
					role: 'accept_all'				//'accept_selected' or 'accept_all'
				},
				secondary_btn: {
					text : 'Settings',
					role : 'settings'				//'settings' or 'accept_necessary'
				}
			},
			settings_modal : {
				title : '<div>Cookie settings</div><div aria-hidden="true" style="font-size: .8em; font-weight: 200; color: #687278; margin-top: 5px;">Powered by <a tabindex="-1" aria-hidden="true" href="https://github.com/orestbida/cookieconsent/" style="text-decoration: underline;">cookie-consent</a></div>',
				save_settings_btn : "Save settings",
				accept_all_btn : "Accept all",
				close_btn_label: "Close",
				cookie_table_headers : [
					{col1: "Name" }, 
					{col2: "Domain" }, 
					{col3: "Expiration" }, 
					{col4: "Description" }, 
					{col5: "Type" }
				],
				blocks : [
					{
						title : "Cookie usage",
						description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
					},{
						title : "Strictly necessary cookies",
						description: 'These cookies are essential for the proper functioning of our website. Without these cookies, the website would not work properly',
						toggle : {
							value : 'necessary',
							enabled : true,
							readonly: true							//cookie categories with readonly=true are all treated as "necessary cookies"
						}
					},{
						title : "Preferences cookies",
						description: 'These cookies allow the website to remember the choices you have made in the past',
						toggle : {
							value : 'preferences',	//there are no default categories => you specify them
							enabled : false,
							readonly: false
						}
					},{
						title : "Analytics cookies",
						description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
						toggle : {
							value : 'analytics',
							enabled : false,
							readonly: false
						},
						cookie_table: [
							{
								col1: '_ga',
								col2: 'google.com',
								col3: '2 years',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							},
							{
								col1: '_gat',
								col2: 'google.com',
								col3: '1 minute',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							},
							{
								col1: '_gid',
								col2: 'google.com',
								col3: '1 day',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							}
						]
					},{
						title : "More information",
						description: 'For any queries in relation to my policy on cookies and your choices, please <a class="cc-link" href="https://orestbida.com/contact">contact me</a>.',
					}
				]
			}
		},
        'cy' : {	
			consent_modal : {
				title :  "Welsh Cookies",
				description :  'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
				primary_btn: {
					text: 'Accept',
					role: 'accept_all'				//'accept_selected' or 'accept_all'
				},
				secondary_btn: {
					text : 'Reject',
					role : 'accept_necessary'				//'settings' or 'accept_necessary'
				}
			},
			settings_modal : {
				title : '<div>Cookie settings</div><div aria-hidden="true" style="font-size: .8em; font-weight: 200; color: #687278; margin-top: 5px;">Powered by <a tabindex="-1" aria-hidden="true" href="https://github.com/orestbida/cookieconsent/" style="text-decoration: underline;">cookie-consent</a></div>',
				save_settings_btn : "Save settings",
				accept_all_btn : "Accept all",
				close_btn_label: "Close",
				cookie_table_headers : [
					{col1: "Name" }, 
					{col2: "Domain" }, 
					{col3: "Expiration" }, 
					{col4: "Description" }, 
					{col5: "Type" }
				],
				blocks : [
					{
						title : "Cookie usage",
						description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
					},{
						title : "Strictly necessary cookies",
						description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
						toggle : {
							value : 'necessary',
							enabled : true,
							readonly: true							//cookie categories with readonly=true are all treated as "necessary cookies"
						}
					},{
						title : "Preferences cookies",
						description: 'These cookies allow the website to remember the choices you have made in the past',
						toggle : {
							value : 'preferences',	//there are no default categories => you specify them
							enabled : false,
							readonly: false
						}
					},{
						title : "Analytics cookies",
						description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
						toggle : {
							value : 'analytics',
							enabled : false,
							readonly: false
						},
						cookie_table: [
							{
								col1: '_ga',
								col2: 'google.com',
								col3: '2 years',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							},
							{
								col1: '_gat',
								col2: 'google.com',
								col3: '1 minute',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							},
							{
								col1: '_gid',
								col2: 'google.com',
								col3: '1 day',
								col4: 'description ...' ,
								col5: 'Permanent cookie'
							}
						]
					},{
						title : "More information",
						description: 'For any queries in relation to my policy on cookies and your choices, please <a class="cc-link" href="https://orestbida.com/contact">contact me</a>.',
					}
				]
			}
		}
	}
});


/*
================================================================
SIDEBAR DRAWERS
================================================================
*/

class Sidebar {
	// The default constructor for each accordion
	constructor(el) {
		this.el = el;
		this.summary = el.querySelector('summary');
		this.content = el.querySelector('.content');
		this.close = el.querySelector('.sidebar-close');
		this.mask = el.querySelector('.sidebar-mask');
		// Store the animation object (so we can cancel it, if needed)
		this.animation = null;
		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isOpening = false;
		// Detect user clicks on the summary element
		this.summary.setAttribute('role', 'button');
		this.summary.setAttribute('aria-expanded', false);
		this.summary.setAttribute('aria-controls', this.content.id);
		
		this.close.setAttribute('role', 'button');
		this.close.setAttribute('aria-expanded', false);
		this.close.setAttribute('aria-controls', this.content.id);

		this.summary.addEventListener('click', (e) => this.onClick(e));
		this.close.addEventListener('click', (e) => this.onClick(e));
		this.mask.addEventListener('click', (e) => this.onClick(e));
	}

  	onClick(e) {
		e.preventDefault();
		if (this.isClosing || !this.el.open) {
		  this.open();
		} else if (this.isOpening || this.el.open) {
		  this.slideOut();
		}
	  }
  
	slideOut() {
		this.isClosing = true;

		const slideOut = [
			{ transform: 'translateX(00%)' },
			{ transform: 'translateX(-100%)' }
		  ];

		if (this.animation) {
		  this.animation.cancel();
		}
	  
		this.animation = this.content.animate(
			slideOut, 
			{
		  duration: 200,
		  easing: 'ease-in-out'
		});
	  
		this.animation.onfinish = () => this.onAnimationFinish(false);
		// If the animation is cancelled, isClosing variable is set to false
		this.animation.oncancel = () => this.isClosing = false;
	}
  
	open() {
		this.el.open = true;
		this.summary.setAttribute('aria-expanded', true);
		this.close.setAttribute('aria-expanded', true);
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame(() => this.slideIn());
	}
  
	// Function called to expand the content with an animation
	slideIn() {
		// Set the element as "being expanding"
		this.isOpening = true;

		const slideOut = [
			{ transform: 'translateX(-100%)' },
			{ transform: 'translateX(0%)' }
		  ];

		// If there is already an animation running
		if (this.animation) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.content.animate(
			slideOut, 
			{
		  // If the duration is too slow or fast, you can change it here
		  duration: 200,
		  // You can also change the ease of the animation
		  easing: 'ease-in-out'
		});
		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish(true);
		// If the animation is cancelled, isOpening variable is set to false
		this.animation.oncancel = () => this.isOpening = false;

	}
  
	// Callback when the shrink or expand animations are done
	onAnimationFinish(open) {
		  // Set the open attribute based on the parameter
		  this.el.open = open;
		  // Clear the stored animation
		  this.animation = null;
		  // Reset isClosing & isOpening
		  this.isClosing = false;
		  this.isOpening = false;

		  this.summary.setAttribute('aria-expanded', open);
		  this.close.setAttribute('aria-expanded', open);

		  if(open){
			tm_body.classList.add('sidebar-open');
		  }else{
			tm_body.classList.remove('sidebar-open');
		  }
	}
  }

  document.querySelectorAll('.sidebar-accordion').forEach((el) => {
	new Sidebar(el);
  });

/*
================================================================
SLIDESHOW
================================================================
*/

function initSlideshows(){
	const slideshows = document.querySelectorAll(".carousel");
    for (var i = 0; i < slideshows.length; i++) {
		var elem = slideshows[i];
		var args = { "pageDots": false, "prevNextButtons": false, "autoPlay": 6000, "wrapAround": true, "pauseAutoPlayOnHover": false};
		var flkty = new Flickity( elem, args);
		var nextButtons = slideshows[i].querySelectorAll('.icon-button');
		for (var i = 0; i < nextButtons.length; i++) {
			nextButtons[i].addEventListener( 'click', function(e) {
				console.log(e.target);
				if(e.target.classList.contains('next-button')){
					flkty.next();
				}
				if(e.target.classList.contains('prev-button')){
					flkty.previous();
				}
			  });
		}
	} 
}

initSlideshows();



/*
================================================================
VIDEOS
================================================================
*/

// const videos = document.querySelectorAll(".video-frame");
// const players = [];
// const buttons = document.querySelectorAll(".play-button");

// function initVideos(){
// 	for (var i = 0; i < videos.length; i++) {
// 		let elem = videos[i];
// 		elem.dataset.id = i;
// 		players.push(new Vimeo.Player(elem));
// 	}
// 	for (var i = 0; i < buttons.length; i++) {
// 		let elem = buttons[i];
// 		elem.dataset.id = i;
// 		elem.addEventListener("click", playVideo);
// 	}
// 	for (var i = 0; i < players.length; i++) {
// 		let player = players[i];
// 		let video = videos[i];
// 		player.on('play', function(data) {
// 			console.log(video);
// 			video.parentElement.classList.add('playing');
// 		});
// 		player.on('pause', function(data) {
// 			console.log(video);
// 			video.parentElement.classList.remove('playing');
// 		});
// 	}
// }

// function playVideo(event){
// 	let elem = event.currentTarget;
// 	let ID = elem.dataset.id
// 	let container = '#video-' + ID;
// 	// console.log(ID);
// 	pauseAllMedia();
// 	players[ID].play();
// 	// container.classList.add('playing');
// }

// function pauseAllMedia() {
// 	for (var i = 0; i < players.length; i++) {
// 		players[i].pause();
// 	}
// }

// function onPlay(){

// }

// initVideos();